import { forwardRef, type HTMLAttributes, type ReactNode } from "react"
import { cn } from "@/lib/cn"

export type AlertVariant = "info" | "success" | "warning" | "danger"

const VARIANT: Record<AlertVariant, string> = {
  info: "border-markv-primary-soft-border bg-markv-primary-soft text-markv-primary-soft-fg",
  success: "border-markv-success-soft-border bg-markv-success-soft text-markv-success-soft-fg",
  warning: "border-markv-warning-soft-border bg-markv-warning-soft text-markv-warning-soft-fg",
  danger: "border-markv-danger-soft-border bg-markv-danger-soft text-markv-danger-soft-fg",
}

export type AlertProps = HTMLAttributes<HTMLDivElement> & {
  variant?: AlertVariant
  title?: ReactNode
}

export const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
  { variant = "info", title, className, children, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      role="alert"
      data-variant={variant}
      className={cn("rounded-md border px-4 py-3 text-sm", VARIANT[variant], className)}
      {...rest}
    >
      {title ? <div className="mb-1 font-semibold">{title}</div> : null}
      {children}
    </div>
  )
})
